import { formatRequest } from "../../utils/function";
import axiosInstance from "../axiosInstance";

export function createTransferPartners(data) {
  return axiosInstance.post(`transfer-partners/create`, formatRequest(data));
}

export function updateTransferPartners(data) {
  return axiosInstance.post(`transfer-partners/update`, formatRequest(data));
}

export function getTransferPartnersList(data) {
  return axiosInstance.post(`transfer-partners/list`, formatRequest(data));
}

export function deleteTransferPartners(data) {
  return axiosInstance.post(`transfer-partners/delete`, formatRequest(data));
}

export function detailsTransferPartners(data) {
  return axiosInstance.post(`transfer-partners/details`, formatRequest(data));
}
